'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _jsxFileName = 'src/new-business/quick-quote/fdi-cover.js';
var _level = require('@marmalade/bling/lib/level');
var _level2 = _interopRequireDefault(_level);
var _button = require('@marmalade/button');
var _button2 = _interopRequireDefault(_button);
var _domain = require('@marmalade/domain');
var _domain2 = _interopRequireDefault(_domain);
var _fieldInfo = require('@marmalade/form/lib/selectors/field-info');
var _actions = require('@marmalade/ldi/lib/quote/actions');
var _selectors = require('@marmalade/ldi/lib/quote/selectors');
var _panel = require('@marmalade/panel');
var _propTypes = require('@marmalade/prop-types');
var _actions2 = require('@marmalade/query/lib/actions');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _propTypes2 = require('prop-types');
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _reactRouterDom = require('react-router-dom');
var _reduxWindow = require('redux-window');
var _form = require('./form');
var _usps = require('./usps');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var NydiLabel = function NydiLabel(_ref) {
  var title = _ref.title,
    apr = _ref.apr,
    creditTotal = _ref.creditTotal,
    deposit = _ref.deposit,
    monthlyPremium = _ref.monthlyPremium,
    payments = _ref.payments,
    premium = _ref.premium,
    onClick = _ref.onClick,
    theme = _ref.theme,
    width = _ref.width;
  var mobile = width < theme.breakpoint_xs;
  return _react2.default.createElement(_glamorous2.default.Div, {
    textAlign: 'center',
    marginBottom: mobile ? theme.space_md : 0,
    minWidth: mobile ? '225px' : 'auto',
    maxWidth: '40%',
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23
    },
    __self: undefined
  }, _react2.default.createElement(_glamorous2.default.H2, {
    fontWeight: '700',
    marginBottom: 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29
    },
    __self: undefined
  }, title), _react2.default.createElement(_glamorous2.default.P, {
    marginBottom: 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32
    },
    __self: undefined
  }, payments, ' monthly payments of'), _react2.default.createElement(_glamorous2.default.H2, {
    marginBottom: 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33
    },
    __self: undefined
  }, '\xA3', monthlyPremium.toFixed(2)), _react2.default.createElement(_glamorous2.default.P, {
    marginBottom: theme.space_xs,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34
    },
    __self: undefined
  }, 'A deposit of \xA3', deposit.toFixed(2)), _react2.default.createElement(_glamorous2.default.P, {
    marginBottom: theme.space_xs,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35
    },
    __self: undefined
  }, 'and a total of \xA3', creditTotal.toFixed(2), ' by instalments (', apr, '% APR Representative)'), _react2.default.createElement(_glamorous2.default.P, {
    marginBottom: theme.space_xs,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38
    },
    __self: undefined
  }, 'or an annual premium of \xA3', premium.toFixed(2)), _react2.default.createElement(_button2.default, {
    onClick: onClick,
    prominence: 'primary',
    text: 'Apply now',
    block: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39
    },
    __self: undefined
  }));
};
NydiLabel.propTypes = {
  title: _propTypes2.string,
  apr: _propTypes2.number,
  deposit: _propTypes2.number,
  miles: _propTypes2.string,
  monthlyPremium: _propTypes2.number,
  creditTotal: _propTypes2.number,
  payments: (0, _propTypes2.oneOfType)([_propTypes2.string, _propTypes2.number]),
  premium: _propTypes2.number,
  onClick: _propTypes2.func,
  theme: _propTypes2.object.isRequired,
  width: _propTypes2.number.isRequired
};
var NydiCoverLabel = (0, _glamorous.withTheme)(NydiLabel);
var FDICover = function (_Component) {
  _inherits(FDICover, _Component);
  function FDICover() {
    var _ref2,
      _this2 = this;
    var _temp, _this, _ret;
    _classCallCheck(this, FDICover);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = FDICover.__proto__ || Object.getPrototypeOf(FDICover)).call.apply(_ref2, [this].concat(args))), _this), _this.renderFDIQuotes = function () {
      var annualQuote = _this.props.fdiQuotes.find(function (quote) {
        return quote.milage === '10000';
      });
      if (!annualQuote) {
        return null;
      }
      if (annualQuote.monthlyPremium === 0) {
        return _react2.default.createElement(_glamorous2.default.H3, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 83
          },
          __self: _this2
        }, 'Sorry, we could not provide a Named Young Driver quote based on the details provided.');
      }
      return _react2.default.createElement(_react2.default.Fragment, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 90
        },
        __self: _this2
      }, annualQuote.monthlyPremium !== 0 ? _react2.default.createElement(NydiCoverLabel, {
        title: 'Named young driver insurance',
        apr: annualQuote.apr,
        deposit: annualQuote.creditDepositAmount,
        payments: annualQuote.creditNumMonthlyPayments,
        monthlyPremium: annualQuote.monthlyPremium,
        premium: annualQuote.premiumIncludingIpt,
        creditTotal: annualQuote.creditTotalPayable,
        onClick: function onClick() {
          document.location.href = (0, _domain2.default)('familycar.wearemarmalade') + '/fdi/new/stage1?quoteRef=' + _this.props.fdiQuoteRef + '&milage=' + annualQuote.milage + '&utm_source=introducer&utm_medium=referral&utm_content=' + _this.props.guid + '&guid=' + _this.props.guid;
        },
        width: _this.props.width,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 92
        },
        __self: _this2
      }) : _react2.default.createElement('h3', {
        style: {
          maxWidth: '40%'
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 110
        },
        __self: _this2
      }, 'Sorry, we could not provide a Named Young Driver quote based on the details provided.'));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(FDICover, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_panel.Panel, {
        id: 'fdiPanel',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 120
        },
        __self: this
      }, _react2.default.createElement(_level2.default, {
        breakpoint: 'xs',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 121
        },
        __self: this
      }, _react2.default.createElement(_react.Fragment, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 122
        },
        __self: this
      }, _react2.default.createElement(_glamorous2.default.Div, {
        width: '100%',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 123
        },
        __self: this
      }, _react2.default.createElement(_usps.FDIUsps, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 124
        },
        __self: this
      }, _react2.default.createElement(_glamorous2.default.Div, {
        display: 'flex',
        justifyContent: 'space-around',
        flexWrap: 'wrap',
        marginBottom: 50,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 125
        },
        __self: this
      }, this.renderFDIQuotes())), _react2.default.createElement(_glamorous2.default.Div, {
        textAlign: 'center',
        minWidth: this.props.width < 576 ? '225px' : 'auto',
        maxWidth: '30%',
        margin: '0 auto',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 134
        },
        __self: this
      }, _react2.default.createElement(_glamorous2.default.P, {
        marginBottom: 0,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 140
        },
        __self: this
      }, 'All policies are fully comprehensive.'))))));
    }
  }]);
  return FDICover;
}(_react.Component);
FDICover.propTypes = {
  history: _propTypes.history.isRequired,
  guid: _propTypes2.string,
  // STP
  postcode: _propTypes2.string,
  width: _propTypes2.number.isRequired,
  fdiQuickQuote: _propTypes2.bool,
  fdiQuotes: _propTypes2.array,
  // DTP
  clearQuotes: _propTypes2.func.isRequired,
  setQueries: _propTypes2.func.isRequired
};
exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(function (state) {
  return {
    postcode: (0, _fieldInfo.getValue)(state, _form.formId, 'postcode'),
    fdiQuotes: (0, _selectors.getFDIQuotes)(state),
    fdiQuoteRef: (0, _selectors.fdiQuoteRef)(state),
    width: (0, _reduxWindow.getWidth)(state)
  };
}, {
  clearQuotes: _actions.clearQuotes,
  setQueries: _actions2.setQueries
})(FDICover));